var STOCKIST_OPTIONS = function(strictLocalize) {
    return [
        {
            label: strictLocalize({
                id: "WcH1AB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "I am new to wholesale"
                    }
                ]
            }),
            value: 0
        },
        {
            label: strictLocalize({
                id: "O9UGZ9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "1-10"
                    }
                ]
            }),
            value: 10
        },
        {
            label: strictLocalize({
                id: "GNPfvF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "11-25"
                    }
                ]
            }),
            value: 25
        },
        {
            label: strictLocalize({
                id: "OPwQyA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "26-50"
                    }
                ]
            }),
            value: 50
        },
        {
            label: strictLocalize({
                id: "EUMXze",
                defaultMessage: [
                    {
                        type: 0,
                        value: "51-100"
                    }
                ]
            }),
            value: 100
        },
        {
            label: strictLocalize({
                id: "JRGyVO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "101-250"
                    }
                ]
            }),
            value: 250
        },
        {
            label: strictLocalize({
                id: "m5d1bs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "251-500"
                    }
                ]
            }),
            value: 500
        },
        {
            label: strictLocalize({
                id: "WHrZkT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "500-1000"
                    }
                ]
            }),
            value: 1000
        },
        {
            label: strictLocalize({
                id: "v//NcM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "More than 1000"
                    }
                ]
            }),
            value: 1001
        }
    ];
};
export var STOCKIST_IOPTIONS = function(strictLocalize) {
    return STOCKIST_OPTIONS(strictLocalize).map(function(option) {
        return {
            label: option.label,
            value: option.value.toString()
        };
    });
};
